import { styled } from "@mui/material";

import Modal from "../../../../../../../../components/Generic/Modal";

export const ConfirmationModal = styled(Modal)(() => ({
  width: "600px !important",
}));

export const ErrorMessage = styled("span")(() => ({
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
}));

export const ItalicErrorMessage = styled("span")(() => ({
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#F04438",
  fontStyle: "italic",
}));
